import React from 'react';
import { FormattedMessage } from 'react-intl';
import { createColumnDefinitionBuilder } from '../../../../../../../../components/items-table/create-column-definition-builder';
import { ReadOnlyCurrencyColumn } from './read-only-currency-column';

import messages from '../../messages';

const dutiesPaidColumnId = 'edit-duties-paid-column';

/**
 * Component that displays the duties paid amount in a read-only currency format
 * @param {object} props - Component props
 * @param {object} props.value - The currency value object containing code (string) and value (number)
 * @returns {JSX.Element|null} Read-only currency column displaying duties paid or null if value is 0
 */
const DutiesPaid = ({ value }) => {
  // Don't show value if it's 0
  if (value?.value === 0) {
    return null;
  }

  return <ReadOnlyCurrencyColumn currencyValue={value} />;
};

/**
 * Column definition for duties paid in the amount summary table
 * @type {() => object} Column definition object for the duties paid column
 */
const dutiesPaidColumnDefinition = createColumnDefinitionBuilder({
  header: <FormattedMessage {...messages.dutiesPaid} />,
  accessor: dutiesPaidColumnId,
  cell: DutiesPaid,
  width: 1.5,
});

export { dutiesPaidColumnId, dutiesPaidColumnDefinition };
